import { render, staticRenderFns } from "./EcpReporte.vue?vue&type=template&id=5132e4ea&scoped=true"
import script from "./EcpReporte.vue?vue&type=script&lang=js"
export * from "./EcpReporte.vue?vue&type=script&lang=js"
import style0 from "./EcpReporte.vue?vue&type=style&index=0&id=5132e4ea&prod&scoped=true&lang=css"
import style1 from "../main.css?vue&type=style&index=1&id=5132e4ea&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132e4ea",
  null
  
)

export default component.exports